import React from "react";

function BtnMedium({ text, icon, color, onClick }) {

  return (
    <button
      className={`btn-medium ${color}`}
      onClick={onClick}
    >
      {
        icon &&
        <i className={`${icon}`}/>
      }
      {text}
    </button>
  );
}

export default BtnMedium;
